export default __webpack_public_path__ + "static/media/emptyView.cc211093.svg";